import { render, staticRenderFns } from "./service-locations-general.vue?vue&type=template&id=a995ffa0&scoped=true&"
import script from "./service-locations-general.vue?vue&type=script&lang=js&"
export * from "./service-locations-general.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-general.vue?vue&type=style&index=0&id=a995ffa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a995ffa0",
  null
  
)

export default component.exports